import Vue from 'vue';
import App from './app.vue';
import axios from 'axios';
import { createRouter } from './route/index';
import install from '@/global/vant-config';
import wx from '@/util/wx';
// import './global/index.css';
const { VUE_APP_CSRF: CSRF } = process.env;
const router = createRouter();

Vue.config.productionTip = false;

Vue.prototype.$axios = axios;

// console.log(install);

wx.init();
Vue.prototype.$wx = wx;
Vue.use(install);

axios.defaults.withCredentials = true;
axios.interceptors.request.use((config) => {
  config.xsrfHeaderName = 'X-CSRF-TOKEN';
  config.xsrfCookieName = CSRF;
  return config;
});

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
